//include 13
jQuery(function(){

    var triggerEvent = 'hover';
    if (typeof window.ontouchstart !== 'undefined') {
        triggerEvent = 'click';
    }

	$('.ttip').tooltipster({
	   	animation: 'fade',
	   	animationDuration: [250,100],
	   	delay: 0,
	   	theme: 'tooltipster-noir',
	   	//trigger: triggerEvent,
		trigger: 'custom',
		triggerOpen: {
			mouseenter: true,
			touchstart: true
		},
		triggerClose: {
			mouseleave: true,
			originClick: true,
			touchleave: true,
			scroll: true,
			tap: true
		},
	   distance: 2
	});


	// Shariff Info - Tooltip
	/*if($(".shariff-pp").length){
		//$('.shariff-pp ul').append('<li class="ttip-blue" title="Datenschutz ist uns sehr wichtig, deswegen haben wir eine von Datenschützern akzeptierte Variante des \'Share-Buttons\' eingebaut. Mit einem Klick auf die nebenstehenden Links werden nicht sofort personenbezogene Daten wie Ihre IP-Adresse an die sozialen Netzwerk übermittelt, sondern erst nach Ihrer aktiven Anmeldung."><span class="fa fa-info"></span></div>');

		var sharifTitleTranslation = window.ppt.translate("sharif.info","Datenschutz ist uns sehr wichtig, deswegen haben wir eine von Datenschützern akzeptierte Variante des \'Share-Buttons\' eingebaut. Mit einem Klick auf die nebenstehenden Links werden nicht sofort personenbezogene Daten wie Ihre IP-Adresse an die sozialen Netzwerk übermittelt, sondern erst nach Ihrer aktiven Anmeldung.");

		$('.shariff-pp ul').append(`<li class="ttip-blue shariff-ttip" title="${sharifTitleTranslation}"><span class="fa fa-info"></span></div>`);
		$('.shariff-pp ul li a').attr('rel', 'nofollow');
	}*/
	//

	var themes = ['tooltipster-noir', 'tooltipster-noir-customized'];

	window.pixelpoint.tooltip = {
		init:function(elements){
			elements.each(function(){
				if($(this).data('tooltipster-ns')){
					try{
						$(this).tooltipster("destroy");
						if($(this).data("original-title"))
							$(this).attr("title",$(this).data("original-title"));
					}
					catch(e){
						$(this).removeData('tooltipster-ns');
					}
				}
				var themes = ['tooltipster-noir', 'tooltipster-noir-customized']; 
				var additionalThemes = $(this).data("tooltip-themes") || [];
				if($.isArray(additionalThemes)){
					themes = themes.concat(additionalThemes);
				}
				else{
					themes.push(additionalThemes);
				}

				var options = {
					animation: 'fade',
					animationDuration: [250,100],
					delay: 0,
					theme: themes,
					trigger: triggerEvent,
					contentCloning: true,
					distance: 2
				}

				if (!!$(this).data("tooltip-content")) {
					var selector = $(this).data("tooltip-content");
					var content = $(selector);
					options.content = content;
				}
				$(this).data("original-title",$(this).attr("title"));
				var self = $(this);
				setTimeout(function(){
					self.tooltipster(options);
				},300);
			});
		}
	};

	window.pixelpoint.tooltip.init($('.ttip-blue'));
/*
	$('.ttip-blue').each(function(){
		var themes = ['tooltipster-noir', 'tooltipster-noir-customized']; 
		var additionalThemes = $(this).data("tooltip-themes") || [];
		if($.isArray(additionalThemes)){
			themes = themes.concat(additionalThemes);
		}
		else{
			themes.push(additionalThemes);
		}

		var options = {
		    animation: 'fade',
		    animationDuration: [250,100],
		    delay: 0,
		    theme: themes,
		    trigger: triggerEvent,
		    contentCloning: true,
		    distance: 2
		}

		if (!!$(this).data("tooltip-content")) {
		    var selector = $(this).data("tooltip-content");
		    var content = $(selector);
		    options.content = content;
		}
		$(this).tooltipster(options);
	});
//*/

});